export const focusableWebComponents =
  'ds-accordion-item, ds-checkbox, ds-input, ds-modal';

export const focusableElements =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not([disabled]),iframe, .vs-btn:not([disabled]), .vs-link-cta:not([disabled]), a[role="button"]:not([disabled])';

export function firstFocusableElement(container) {
  const firstFocusableWebComponent = container.querySelectorAll(
    focusableWebComponents
  )[0];
  let firstFocusableElement;

  if (firstFocusableWebComponent) {
    firstFocusableElement =
      firstFocusableWebComponent.shadowRoot.querySelectorAll(
        focusableElements
      )[0];
  } else {
    firstFocusableElement = container.querySelectorAll(focusableElements)[0];
  }

  return firstFocusableElement;
}

export function lastFocusableElement(container) {
  const focusableContent = container.querySelectorAll(focusableElements);
  const lastFocusableElement = focusableContent[focusableContent.length - 1];

  return lastFocusableElement;
}

export function trapFocus(container, e) {
  // Check if it's a modal
  const isModal = container.classList.contains('vs-modal-container');
  
  if (isModal) {
    return trapModalFocus(container, e);
  }

  // Default trap focus behavior for non-modal components
  return trapDefaultFocus(container, e);
}

function trapModalFocus(container, e) {
  const focusableElementsWithinContent = container.querySelector('.vs-modal-content')
    .querySelectorAll(focusableElements);
  const firstContentElement = focusableElementsWithinContent[0];
  const lastContentElement = focusableElementsWithinContent[focusableElementsWithinContent.length - 1];
  const closeButton = container.querySelector('.vs-btn-close-modal');

  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) { // shift + tab
    if (e.target === firstContentElement) {
      closeButton.focus();
      e.preventDefault();
    } else if (e.target === closeButton) {
      lastContentElement.focus();
      e.preventDefault();
    }
  } else { // tab
    if (e.target === lastContentElement) {
      closeButton.focus();
      e.preventDefault();
    } else if (e.target === closeButton) {
      firstContentElement.focus();
      e.preventDefault();
    }
  }
}

function trapDefaultFocus(container, e) {
  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
  if (!isTabPressed) {
    return;
  }

  const focusableContent = container.querySelectorAll(focusableElements);
  const firstElement = focusableContent[0];
  const lastElement = focusableContent[focusableContent.length - 1];

  if (e.shiftKey) { // shift + tab
    if (e.target === firstElement) {
      lastElement.focus();
      e.preventDefault();
    }
  } else { // tab
    if (e.target === lastElement) {
      firstElement.focus();
      e.preventDefault();
    }
  }
}
